import { API_BASE_URL } from '../../constants/appConstants';
import { authenticatedRequest } from '../authService';

const SUPERADMIN_BASE_URL = `${API_BASE_URL}/superadmin`;

/**
 * Fetch dashboard statistics
 * @returns {Promise<Object>} Response with dashboard stats
 */
export const fetchDashboardStats = async () => {
  const url = `${SUPERADMIN_BASE_URL}/dashboard/stats/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch dashboard statistics');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching dashboard statistics:', error);
    throw new Error(error.message || 'Failed to fetch dashboard statistics');
  }
};

/**
 * Fetch recent activities across the system
 * @returns {Promise<Object>} Response with recent activities
 */
export const fetchRecentActivities = async () => {
  const url = `${SUPERADMIN_BASE_URL}/dashboard/recent-activities/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch recent activities');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching recent activities:', error);
    throw new Error(error.message || 'Failed to fetch recent activities');
  }
};

/**
 * Fetch top users by total records
 * @returns {Promise<Object>} Response with top users
 */
export const fetchTopUsersByRecords = async () => {
  const url = `${SUPERADMIN_BASE_URL}/dashboard/top-users/`;

  try {
    const response = await authenticatedRequest(url, {
      method: 'GET',
    });

    if (!response.success) {
      throw new Error(response.error || 'Failed to fetch top users');
    }

    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching top users:', error);
    throw new Error(error.message || 'Failed to fetch top users');
  }
};